import { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsArrowRight, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import gd1 from "../../assets/1.png";
import gd2 from "../../assets/2.jpg";
import gd3 from "../../assets/3.jpg";
import gd4 from "../../assets/4.jpg";
import gd7 from "../../assets/7.jpg";
import gd11 from "../../assets/11.png";
import "./projectlanding.css";
import imgMallika from "../../assets/Mallika.jpeg";
import imgHoof from "../../assets/Hoof.jpeg";
import imgExtraw from "../../assets/Extraw.jpeg";
import imgSkin from "../../assets/Skin.jpeg";
import imgMadras from "../../assets/Madras MCPL.jpeg";
import imgBuildcare from "../../assets/Buildcare.jpeg";
import imgSparkle from "../../assets/Sparkle.jpeg";
import imgAdorable from "../../assets/Adorable.jpeg";
import imgTharun from "../../assets/Tharun.jpeg";
import imgBNI from "../../assets/BNI.jpeg";
import imgVishwaksenaa from "../../assets/Vishwaksenaa.jpeg";
import imgLogosDesign from "../../assets/logos-design.jpeg";


const projects = [
  // E-commerce
  {
    id: 2,
    title: "Mallika Shopping",
    category: "ecommerce",
    link: "https://mallikaonline.in/",
    image: imgMallika,
  },
  {
    id: 3,
    title: "Hoof & Arrow",
    category: "ecommerce",
    link: "https://hoofandarrow.netlify.app/",
    image: imgHoof,
  },
  // Business Websites
  {
    id: 1,
    title: "Extraw Designs",
    category: "business",
    link: "https://extrawdesigns.com/",
    image: imgExtraw,
  },
  {
    id: 4,
    title: "Skin Health Centre",
    category: "business",
    link: "https://skinhealthcentre.in/",
    image: imgSkin,
  },
  {
    id: 5,
    title: "Madras MCPL",
    category: "business",
    link: "https://madrasmcpl.com/",
    image: imgMadras,
  },
  // { id: 6,  title: 'Sparkle Consulting',  category: 'business',  link: 'https://sparkleconsulting.in/',     image: imgSparkle },
  {
    id: 7,
    title: "Zime AI",
    category: "business",
    link: "https://zime.ai/",
    image:
      "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&h=600&fit=crop",
  },
  // Landing Pages
  {
    id: 8,
    title: "Ekattor8",
    category: "landing",
    link: "https://adorable-jalebi-e9d2de.netlify.app/",
    image: imgAdorable,
  },
  // { id: 9,  title: 'Landing Page Way',    category: 'landing',   link: 'https://landingpageway.netlify.app/', image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=800&h=600&fit=crop' },
  // { id: 10, title: 'Landing Page Way 2',  category: 'landing',   link: 'https://landingpageway2.netlify.app/', image: 'https://images.unsplash.com/photo-1523475472560-d2df97ec485c?w=800&h=600&fit=crop' },
  // Software
  {
    id: 11,
    title: "HRMs Software",
    category: "software",
    link: "https://firewings.in/",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop",
  },
  {
    id: 12,
    title: "Billing Software",
    category: "software",
    link: "https://quadverge-billingsoftware.netlify.app/",
    image:
      "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&h=600&fit=crop",
  },
  // Social Media
  {
    id: 13,
    title: "Extraw Designs",
    category: "social",
    link: "https://www.instagram.com/extrawdesigns9/",
    image: imgExtraw,
  },
  {
    id: 14,
    title: "Tharun's Brainery",
    category: "social",
    link: "https://www.instagram.com/tharuns_brainery/",
    image: imgTharun,
  },
  {
    id: 15,
    title: "BNI Luminaries",
    category: "social",
    link: "https://www.instagram.com/bni_luminaries_chennainorth/",
    image: imgBNI,
  },
  // Graphic Designing
  {
    id: 16,
    title: "Graphic Design 1",
    category: "graphic",
    link: "#",
    image: gd1,
  },
  {
    id: 17,
    title: "Graphic Design 2",
    category: "graphic",
    link: "#",
    image: gd2,
  },
  {
    id: 18,
    title: "Graphic Design 3",
    category: "graphic",
    link: "#",
    image: gd3,
  },
  {
    id: 19,
    title: "Graphic Design 4",
    category: "graphic",
    link: "#",
    image: gd4,
  },
  {
    id: 20,
    title: "Graphic Design 7",
    category: "graphic",
    link: "#",
    image: gd7,
  },
  {
    id: 21,
    title: "Graphic Design 11",
    category: "graphic",
    link: "#",
    image: gd11,
  },
  // Logo Designing
  {
    id: 26,
    title: "Logo Designs",
    category: "logo",
    image: imgLogosDesign,
    tags: ["Logo Design", "Branding"],
    desc: "Custom logo designs crafted to represent brand identity with clarity and creativity.",
  },
];

const filters = [
  { key: "all", label: "All Projects" },
  { key: "ecommerce", label: "E-commerce" },
  { key: "business", label: "Business Websites" },
  { key: "landing", label: "Landing Pages" },
  // { key: 'software',  label: 'Software' },
  { key: "social", label: "Social Media" },
  { key: "graphic", label: "Graphic Designing" },
  { key: "logo", label: "Logo Designing" },
];

export const Projectlanding = () => {
  const [active, setActive] = useState("all");
  const [current, setCurrent] = useState(0);
  const autoRef = useRef(null);

  const filtered =
    active === "all" ? projects : projects.filter((p) => p.category === active);

  // reset index when filter changes
  useEffect(() => {
    setCurrent(0);
  }, [active]);

  // auto-advance
  useEffect(() => {
    autoRef.current = setInterval(() => {
      setCurrent((c) => (c + 1) % filtered.length);
    }, 3500);
    return () => clearInterval(autoRef.current);
  }, [filtered]);

  const prev = () => {
    clearInterval(autoRef.current);
    setCurrent((c) => (c - 1 + filtered.length) % filtered.length);
  };

  const next = () => {
    clearInterval(autoRef.current);
    setCurrent((c) => (c + 1) % filtered.length);
  };

  const getPos = (i) => {
    const len = filtered.length;
    const diff = (i - current + len) % len;
    if (diff === 0) return "center";
    if (diff === 1 || diff === len - 1) return diff === 1 ? "right" : "left";
    return "hidden";
  };

  return (
    <section className="pl-section">
      <Container>
        {/* Header */}
        <div className="text-center mb-4">
          <span className="project-badge">Our Works</span>
          <h2 className="pl-title">Featured Projects</h2>
          <p className="pl-sub">
            Real-time results for real businesses across industries
          </p>
        </div>

        {/* Filters */}
        <div className="pl-filters">
          {filters.map((f) => (
            <button
              key={f.key}
              className={`pl-filter-btn ${active === f.key ? "active" : ""}`}
              onClick={() => setActive(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* Carousel */}
        <div className="pl-carousel-wrap">
          <button
            className="pl-nav pl-nav-left"
            onClick={prev}
            aria-label="Previous"
          >
            <BsChevronLeft />
          </button>

          <div className="pl-carousel">
            {filtered.map((p, i) => {
              const pos = getPos(i);
              if (pos === "hidden") return null;
              return (
                <div key={p.id} className={`pl-slide pl-slide--${pos}`}>
                  <a
                    href={p.category === "graphic" ? undefined : p.link}
                    target={p.category === "graphic" ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    className="pl-slide-inner"
                    style={{
                      cursor: p.category === "graphic" ? "default" : "pointer",
                    }}
                  >
                    <img
                      src={p.image}
                      alt={p.title}
                      className="pl-slide-img"
                      loading="lazy"
                    />
                    {pos === "center" && (
                      <div className="pl-slide-overlay">
                        <p className="pl-slide-title">{p.title}</p>
                        <span className="pl-slide-link">
                          View Project <BsArrowRight />
                        </span>
                      </div>
                    )}
                  </a>
                </div>
              );
            })}
          </div>

          <button
            className="pl-nav pl-nav-right"
            onClick={next}
            aria-label="Next"
          >
            <BsChevronRight />
          </button>
        </div>

        {/* Dots */}
        <div className="pl-dots">
          {filtered.map((_, i) => (
            <button
              key={i}
              className={`pl-dot ${i === current ? "active" : ""}`}
              onClick={() => setCurrent(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center mt-5">
          <Link to="/projects" className="pl-view-more">
            View More Projects <BsArrowRight />
          </Link>
        </div>
      </Container>
    </section>
  );
};
